
export const removeNullValues = array => array?.filter(value => value !== null);

export const hasNullValue = (array, property) => {
  return array?.some(obj => obj?.[property] === null);
};
